import { nanoid } from "nanoid";
import { useCallback } from "react";
// @ts-ignore
import { useSetRecoilState } from "recoil";
import { snackbarIdState, snackbarOpenState, snackbarPropsState } from "./recoil";
const useSnackbar = () => {
    const setSnackbarOpen = useSetRecoilState(snackbarOpenState);
    const setSnackbarId = useSetRecoilState(snackbarIdState);
    const setSnackbarProps = useSetRecoilState(snackbarPropsState);
    const setSnackbar = useCallback((props) => {
        setSnackbarOpen(true);
        setSnackbarProps(props);
        setSnackbarId(nanoid());
    }, [setSnackbarOpen, setSnackbarProps, setSnackbarId]);
    const closeSnackbar = useCallback(() => {
        setSnackbarOpen(false);
    }, [setSnackbarOpen]);
    return { setSnackbar, closeSnackbar };
};
export default useSnackbar;
